import { CheckboxProps } from "./types/checkboxProps";
import './checkbox.scss';

const Checkbox = (props: CheckboxProps) => {
    const {setIsFocused, ...rest} = props;
    return (
        <input {...rest} id="checkboxes" onChange={props.onChange} type="checkbox" 
        onFocus={() => { if(props.setIsFocused) props.setIsFocused(true) }}
        onBlur={() => { if(props.setIsFocused) props.setIsFocused(false) }}></input>
    )
}

export default Checkbox